import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface GalleryNavButtonProps {
  direction: "prev" | "next";
  onClick: () => void;
  className?: string;
  themeClassName?: string;
  ariaLabel: string;
}

export function GalleryNavButton({
  direction,
  onClick,
  className,
  themeClassName,
  ariaLabel,
}: GalleryNavButtonProps) {
  const Icon = direction === "prev" ? ChevronLeft : ChevronRight;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        "flex size-12 shrink-0 items-center justify-center transition-colors",
        themeClassName ?? "bg-foreground text-background hover:opacity-80",
        className
      )}
    >
      <Icon className="size-6" strokeWidth={1.5} />
    </button>
  );
}
